import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { SpacingStack } from '@components/SpacingStack';
import { CloudImage } from '@components/CloudImage';
import { Text } from '@components/typography';
import {
  Container,
  controlStyles,
  ImgContainer,
  OpeningQuote,
  StyledBox,
  StyledNewsroomCarousel,
  TextContainer,
  DescTextContainer,
} from './NewsroomCarousel.styles';

import './carousel.css';

interface PressFeature
  extends Readonly<{
    title: string;
    subtitle: string;
    link: string;
    img: string;
    pressImg: string;
  }> {}

interface NewsroomCarouselProps {
  features: ReadonlyArray<PressFeature>;
}

export const NewsroomCarousel: React.FC<NewsroomCarouselProps> = ({ features }) => {
  const isMobileDevice = useThemeMediaQuery('below_sm');
  return (
    <StyledNewsroomCarousel vertical={!isMobileDevice} defaultControlsConfig={controlStyles} autoplay={true}>
      {features.map((feature, index) => (
        <Container key={index}>
          <ImgContainer src={feature.img} />
          <TextContainer>
            <StyledBox backgroundColor="mono7">
              <SpacingStack spacing={6}>
                <div>
                  <CloudImage alt="" style={{ maxWidth: '165px' }} src={feature.pressImg} optimization="aggressive" />
                </div>
                <div style={{ position: 'relative' }}>
                  <OpeningQuote>“</OpeningQuote>
                  <DescTextContainer variant="dek24" color="purple6" tagName="span">
                    {ReactHtmlParser(`${feature.subtitle}<span class="ending-quote">”</span>`)}
                  </DescTextContainer>
                </div>
                <a target="__blank" href={feature.link} aria-label={feature.link} style={{ alignSelf: 'flex-end' }}>
                  <Text variant="featureHed17" color="purple4" tagName="span">
                    Read more
                  </Text>
                </a>
              </SpacingStack>
            </StyledBox>
          </TextContainer>
        </Container>
      ))}
    </StyledNewsroomCarousel>
  );
};
